export default __webpack_public_path__ + "static/service_01-70738238fc165efd6b1f1e7985555862.jpg";